import { FC } from "react";
import { ToolbarWrapper } from "../../../components/plugins";
import { useAppContext } from "../../../system/providers/appContextProvider";
import { useTabsContext } from "../../../system/providers/tabsProvider";
import { GridFilterAction } from "../../../system/hooks/useGridFilter";
import { IExportToolsViewDTO } from "../../../libs/coreapi-dto/dirs/exportDocument";
import { ExportDocumentDataProvider } from "../../../Services/DataProviders/ExportDocumentDataProvider";
import { ExportDocumentToolsPanel } from "./components/ExportDocumentToolsPanel";

interface IExportDocumentToolsCommandsPanelProps {
    data: IExportToolsViewDTO[];
    selectedItem: IGridRow | undefined;
    permission?: IPermission;
    getView: VoidFunction;
    dispatchGridFilter?: (value: GridFilterAction) => void;
}
export const ExportDocumentToolsCommandsPanel: FC<IExportDocumentToolsCommandsPanelProps> = (props) => {
    const { data, selectedItem, permission, getView, dispatchGridFilter, } = props || {};

    const appCtx = useAppContext();
    const tabContext = useTabsContext();
    const exportDocumentDataProvider = new ExportDocumentDataProvider(appCtx.coreApiService)

    return (
        <>
            <ToolbarWrapper>
                <ExportDocumentToolsPanel
                    add={{
                        onClick: () => {
                            tabContext.openChild("export_document_tools_create_plugin", "create", undefined, () => {
                                getView();
                            });
                        },
                    }}
                    edit={{
                        onClick: () => {
                            if (selectedItem)
                                tabContext.openChild("export_document_tools_create_plugin", "edit", selectedItem.idGlobal, () => {
                                    getView();
                                });
                        },
                        disabled: !selectedItem,
                    }}
                    copy={{
                        onClick: () => {
                            if (selectedItem)
                                tabContext.openChild("export_document_tools_create_plugin", "copy", selectedItem.idGlobal, () => {
                                    getView();
                                });
                        },
                        disabled: !selectedItem,
                    }}
                    delete={{
                        onClick: () => {
                            if (selectedItem)
                                exportDocumentDataProvider.markDelete(selectedItem.idGlobal, () => {
                                    getView();
                                });
                        },
                        disabled: !selectedItem || data?.find((x) => x.idGlobal === selectedItem?.idGlobal)?.deleted,
                    }}
                    restore={{
                        onClick: () => {
                            if (selectedItem)
                                exportDocumentDataProvider.restore(selectedItem.idGlobal, () => {
                                    getView();
                                });
                        },
                        disabled: !selectedItem || !data?.find((x) => x.idGlobal === selectedItem?.idGlobal)?.deleted,
                    }}
                    showDeleted={{
                        disabled: false,
                        onChecked: (e) => dispatchGridFilter?.({ type: 'showDeleted', payload: e }),
                    }}
                    refresh={{
                        onClick: getView
                    }}                   
                    permission={permission}
                />
            </ToolbarWrapper>           
        </>
    )
}
